export enum ClassroomSchool {
  UrbanClassroom = 12,
  RuralClassroom = 2
}
